import {
  FormFieldsBaseConfig,
  AttributesBaseConfig,
} from "../components/react-awesome-query-builder/config/config";

export const FormFieldsInitialConfig = FormFieldsBaseConfig;
export const AttributesInitialConfig = AttributesBaseConfig;
